import { liveQuoteFormApiConnector } from 'apiConnector/secondary-market/live/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function fetchLiveInteractionClientEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { interactClient } = liveQuoteFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_CLIENT_RELATED_FETCH_REQUESTED'),
      mergeMap(({ tabId, request }) => {
        return interactClient(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => liveThunks.linkedToClientReceivedThunk(tabId, data)),
          catchError((err: Error) => {
            return of(liveInputFormActions.clientRequestFailed(tabId, err.message));
          }),
        );
      }),
    );
  };
}
